import { createSelector } from 'reselect';
import currentBusinessSelector from 'selectors/service/currentBusinessSelector';

export const businessMinLargePartySizeSelector = createSelector(
  currentBusinessSelector,
  (currentBusiness) => {
    if (
      !currentBusiness ||
      !currentBusiness.distinguishLargeParties ||
      !currentBusiness.minLargePartySize
    ) {
      return undefined;
    }

    return currentBusiness.minLargePartySize;
  }
);
